import { useOutletContext } from 'react-router-dom'
import MissionVisionLayout from '../components/MissionVisionLayout/MissionVisionLayout'

function CSR() {
  const { sectiondata } = useOutletContext() || {}

  return (
    <div>
      <MissionVisionLayout data={sectiondata} />
    </div>
  )
}

export default CSR
